import { APP_CREATION_STEPS } from './constants';
import translator from '@/locales';

function getDraftAppNextStep(currentStep) {
  const steps = Object.values(APP_CREATION_STEPS);
  const numberOfSteps = steps.length;
  const indexOfCurrentStep = steps.findIndex(step => step === currentStep);

  if (indexOfCurrentStep === -1) {
    throw Error(translator.t('UNKNOWN_ERROR'));
  }

  if (indexOfCurrentStep === numberOfSteps - 1) {
    return false;
  }

  return steps[indexOfCurrentStep + 1];
}

export default getDraftAppNextStep;
